import { SELECTORS } from './constants';

/**
 *  Decode Fields - decodes json input
 *
 * @param inputObject - list of fields with value transformed using transformInputToJson
 * @returns String
 * e.g filters[0][field]=cc_rewards_name&filters[asd][comparator]=eq&filters[asd][value]=Qantas%20Frequen
 */
function decodeFields(fields) {
  if (!fields) {
    return '';
  }

  const comparatorMap = {
    '<=': 'lte',
    '<': 'lt',
    '===': 'eq',
    '!==': '!eq',
    '>=': 'gte',
    '>': 'gt',
    '|==': 'in',
  };

  const extractURI = ({
    fieldName,
    idx,
    rawValue,
  }) => {
    const [, comparator, value] = rawValue.match(/^([><=!]+)(.+)$/);
    const shouldSetInComparator = value.indexOf('/') !== -1;
    const removeComparator = new RegExp(comparator, 'g');
    const removeSlash = new RegExp('/', 'g');
    let uriComparator = comparatorMap[comparator];
    let uriValue = value.replace(comparator, '');
    const shoulOmitFilter = uriValue === 'all';

    if (shoulOmitFilter) {
      return null;
    }

    if (shouldSetInComparator) {
      uriComparator = 'in';
      uriValue = value.replace(removeSlash, ',');
    }

    uriValue = uriValue.replace(removeComparator, '');

    return [
      `filters[${idx}][field]=${fieldName}`,
      `filters[${idx}][comparator]=${uriComparator}`,
      `filters[${idx}][value]=${uriValue}`,
    ].join('&');
  };

  const decodedFields = Object.keys(fields)
    .reduce((acc, name) => {
      const bindWithFieldName = value => [name, value];
      const rawValues = fields[name]
        .split(',')

        .map(bindWithFieldName);
      return [...acc, ...rawValues];
    }, [])
    .map(([name, value], idx) =>
      extractURI({
        rawValue: value,
        fieldName: name,
        idx,
      }),
    );

  return decodedFields
    .filter(field => field !== null)
    .join('&');
}

/**
 * Transforms input fields in array format into json format (property name and value)
 *
 * @param inputArray - list of fields with value
 * @returns {{}} - e.g {bonusPoints: ">=1", annualFee: ">=0,<=199"}
 */
function transformInputToJson(inputArray) {
  const fields = inputArray.reduce((prevAcc, field) => {
    const acc = Object.assign({}, prevAcc);

    if (!acc[field.name]) {
      acc[field.name] = field.value;
    } else {
      acc[field.name] += `/${field.value}`;
    }

    acc[field.name] = transformFilterValue(acc, field);

    return acc;
  }, {});

  return fields;
}

function transformCalcInputToJson(inputArray, $form) {
  const fields = inputArray.reduce((prevAcc, field) => {
    const acc = Object.assign({}, prevAcc);
    const UNFORMAT_IDENTIFIER = 'data-autoformat-unformat-val';
    const $input = $form.find(`[name="${field.name}"]`);
    acc[field.name] = $input.is(`[${UNFORMAT_IDENTIFIER}]`) ? $input.attr(UNFORMAT_IDENTIFIER) : field.value;
    return acc;
  }, {});

  return fields;
}

function transformFilterValue(acc, field) {
  let newValue = acc[field.name];
  const QANTAS = 'Qantas Frequent Flyer';
  const VELOCITY = 'Velocity Frequent Flyer';
  if (acc[field.name] === '===Other') {
    newValue = `!==${QANTAS},!==${VELOCITY}`;
  } else if (acc[field.name] === `===${QANTAS}/===Other`) {
    newValue = `!==${VELOCITY}`;
  } else if (acc[field.name] === `===${VELOCITY}/===Other`) {
    newValue = `!==${QANTAS}`;
  }
  return newValue;
}

function trackFilterEvent(action, label) {
  $.trackEvent('CCF Filter', action, label);
}

function trackFilterEventViaField($field) {
  const { TRACKING_DATA_ATTR_LABEL, TRACKING_DATA_ATTR_ACTION } = SELECTORS;
  const action = $field.attr(TRACKING_DATA_ATTR_ACTION);
  const label = $field.attr(TRACKING_DATA_ATTR_LABEL) ? $field.attr(TRACKING_DATA_ATTR_LABEL) : $field.val();
  trackFilterEvent(action, label);
}

/**
 * Removes a field from the form
 * Where is this used: Reward template displays 2 different types of field depending on which view (mobile / desktop)
*/
function removeUnnecessaryFields(selector) {
  $(selector).remove();
}

function formatCurrency(amount) {
  const searchValue = /(\d)(?=(\d{3})+(?!\d))/g;
  const formattedAmount = amount.toString().replace(searchValue, '$1,');
  return `$${formattedAmount}`;
}

export {
  decodeFields,
  transformInputToJson,
  transformCalcInputToJson,
  trackFilterEvent,
  trackFilterEventViaField,
  removeUnnecessaryFields,
  formatCurrency,
};
